import React, { useState } from 'react'
import { withApollo } from '@apollo/client/react/hoc'
import { Redirect } from 'react-router'

import SideList from './SideList'
import ItemView from './ItemView'
// import { UserDataContext } from 'sections/user/pages/User'

import useRouterState from '../hooks/useRouterState'
import useAddNewRecord from '../hooks/useAddNewRecord'
import useMutations from '../hooks/useMutations'
import useRedirect from '../hooks/useRedirect'
import useMultiEdit from '../hooks/useMultiEdit'

import { StyledRow } from '../styled'
import { useHistory, useLocation } from 'react-router-dom'

const SectionHandler = props => {
	const history = useHistory()
	const location = useLocation()
	const routerStateProps = useRouterState({ history, location, ...props })
	const addNewRecord = useAddNewRecord({ history, location, ...props, ...routerStateProps })
	const multiEditProps = useMultiEdit({ sectionData: routerStateProps.sectionData, section: routerStateProps.section })
	const mutationProps = useMutations({ history, ...props, ...routerStateProps, addNewRecord, multiEdit: multiEditProps })
	const { handler, addNewRecord: canAddNewRecord, sideListProps } = routerStateProps.sectionData

	const componentProps = {
		...canAddNewRecord && { addNewRecord },
		...mutationProps,
		...props,
		...routerStateProps,
		history,
		location,
		sideListProps,
		multiEdit: multiEditProps,
		isWideSide: routerStateProps?.sectionData?.wideSideList
	}

	const redirectPath = useRedirect(componentProps)
	if(redirectPath) {
		return <Redirect to={redirectPath} />
	}

	if(handler) {
		const HandlerOverride = handler
		return <HandlerOverride {...componentProps}/>
	}

	if(routerStateProps.subsectionData.overrideHandler) {
		const HandlerOverride = routerStateProps.subsectionData.component
		return <HandlerOverride {...componentProps}/>
	}

	return <DefaultSectionLayout {...componentProps}/>
}

export const DataContextByDiffPages = React.createContext({})

export const DefaultSectionLayout = props => {
	const { isWideSide, sideListProps, ...componentProps } = props
	const [changedValues, setChangedValues] = useState({})
	return(
		<DataContextByDiffPages.Provider value={{ changedValues, setChangedValues }}>
			<StyledRow isWideSide={isWideSide}>
				<SideList {...sideListProps} {...componentProps}/>
				<ItemView {...componentProps}/>
			</StyledRow>
		</DataContextByDiffPages.Provider>
	)
}

export default withApollo(SectionHandler)
